import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ReactGA from 'react-ga4';
import './index.css';
import App from './App';
import ConfirmSubscription from './ConfirmSubscription';
import PrivacyPolicy from './PrivacyPolicy';
import SubscribePage from './SubscribePage';
import PastIssuesPage from './PastIssuesPage';

// Initialize Google Analytics
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
if (GA_MEASUREMENT_ID) {
  ReactGA.initialize(GA_MEASUREMENT_ID);
  ReactGA.send('pageview');
}

function MagazineRoute() {
  React.useEffect(() => {
    window.location.href = window.location.pathname + window.location.search;
  }, []);
  return null;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/subscribe" element={<SubscribePage />} />
        <Route path="/issues" element={<PastIssuesPage />} />
        <Route path="/past-issues" element={<PastIssuesPage />} />
        <Route path="/magazine/:id" element={<MagazineRoute />} />
        <Route path="/confirm" element={<ConfirmSubscription />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/snaps" element={<App />} />
        <Route path="/comics" element={<App />} />
        <Route path="/briefs" element={<App />} />
        <Route path="/toollab" element={<App />} />
        <Route path="/editorials" element={<App />} />
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
